<template>
    <v-dialog-old ref="dialog" id="step_three" @hidden="resetData">
        <MassEditDialog
            ref="priceMassActionsDialog"
            :selectedPriceLines="selectedItems"
            @updateTable="updateTable"
            @tagsUpdated="updateTags"
        />
        <button :disabled="!selectedItems.length" @click="openMassActions">
            <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFAAAABQCAYAAACOEfKtAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAHDSURBVHhe7dy/K0VhHMfxS6LkR8ogSTKaKINBWQz+ABZ28Rcwm/wL/gWzjBYjZguTsigpGwOfU8+p73HPo+c+3xt1zvtV7+XUs3zq3nNdjg4AAACAfCvqyNGaarVD9eXoWLUaAzrZAV/UeULPigEDO+B1cSHBhWLAgAGdYgMOqkXTkCrFBhxT9kwTm1UVsQEnVXm9aF6VYgPuKnumiXW9ShmwtxjQWfKAA2rKVLwnlmIDDit7pomNq4rYgL+JDdhKDOhkB3xXtwm9KQYM7IA5MaCqGya11g+4pPYdLSsAAJBjTm06WlCtxudAJwZ0sgN+qteEPhQDBnZAvo3JwIBODOjUzwG3Vd17ZpO6VBX9HJBfKhUXEjCg0c8BZ1TdTytNalVVcBNxYkAnO+CTOk3oQTFgYAfMiQFV3TCptX7ADXXmaEsBAAD8Az4HOjGgEwM62QFvVN3TOT+7UgwY2AH5OisDAzrFBhxV9hnhaVWKDbiu7JkmdqIqYgPyqFd9Xa9SBuyt5AFHlP3vHBOqFBuw+It/e6aJ7akKbiJODOhkB7xXOwndKQYM7IA5MaCqGya11g9Y3FUeHR0oAAAAAMAf6HS+AWpqFD4ChQwgAAAAAElFTkSuQmCC" width="25" height="25">
            {{ selectedItems.length }}
        </button>
        <button style="top: 0" @click="exportPricelist">
            <img width="25" src="data:image/svg+xml;base64,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">
            Экспорт
        </button>
        <v-table class="stepThreeTable" :id="'stepThreeTable_'+ priceListFileId"
            :request-uri="'doctu/' + this.priceListFileId + '/getLinesWithTags'"
            :default-filter="filter"
            pagesize="100"
            :show-eye="false"
            @updating="tableIsPreparing"
            @updated="tableIsReadyToOperate"
            ref="table"
        >
            <template v-slot:header>
                <v-tr>
                    <v-th name="checkbox" title="A" width="30"></v-th>
                    <v-th width="125" name="code" title="Код">
                        Код
                    </v-th>
                    <v-th width="280" name="category" title="Категории">
                        Категории
                    </v-th>
                    <v-th minwidth="400" name="name_with_description" title="Название и Описание">
                        Название и Описание
                    </v-th>
                    <v-th width="120" name="mixedPrice" title="Цена">
                        Цена
                    </v-th>
                    <v-th width="450" name="tags" title="Теги">
                        Теги
                    </v-th>
                    <v-th width="25" name="manualAction" title="Удаление строки" v-tooltip="{content: 'Удалить строку прайс-листа'}" >
                        С
                    </v-th>
                </v-tr>
                <v-tr>
                    <th>
                        <input v-if="allChecked"
                               id="pricelistMassEditCheckbox"
                               type="checkbox"
                               :value="true"
                               checked
                               @click.stop.prevent="handleSelect">
                        <input v-else-if="!allChecked && tableIsReady && !checkAllRowsAreNotSelected()"
                               type="checkbox"
                               :value="true"
                               indeterminated
                               @click.stop.prevent="handleSelect">
                        <input v-else
                               type="checkbox"
                               :value="true"
                               @click.stop.prevent="handleSelect">
                    </th>
                    <v-th name="code" v-slot="{filter}">
                        <v-input v-model="filter.value" />
                    </v-th>
                    <v-th name="category" v-slot="{filter}">
                        <v-select
                            v-model="filter.value"
                            :options='[
                                {
                                    value: "",
                                    text: "\u00a0"
                                },
                             ...categories.map(row => {
                                return {
                                    value: row,
                                    text: row
                                };
                             })
                        ]'
                        ></v-select>
                    </v-th>
                    <v-th name="name_with_description" v-slot="{filter}">
                        <v-input v-model="filter.value" />
                    </v-th>
                    <v-th name="mixedPrice" v-slot="{filter}">
                        <v-input v-model="filter.value" />
                    </v-th>
                    <v-th name="tags" v-slot="{filter}">
                        <v-input v-model="filter.value" />
                    </v-th>
                    <v-th name="manualAction"/>
                </v-tr>
            </template>
            <template v-slot:row="{ item, index }">
                <v-tr :class="{'hover': item.status !=='PARSED', 'pointer': item.status !=='PARSED'}"
                    @click="(row, event) => handleRowClick(event, item, row, index)">
                    <td>
                        <input
                            type="checkbox"
                            name="checkThisItem"
                            :checked="isChecked(item)"
                        >
                    </td>
                    <v-td name="code">
                        <span>{{ item.code === null ? '---' : item.code }}</span>
                    </v-td>
                    <v-td name="category" width="280">
                        <template v-if="item.category.length">
                            <div v-for="category in item.category">
                                {{ category }}
                            </div>
                        </template>
                        <span v-else>----</span>
                    </v-td>
                    <v-td name="name_with_description" minwidth="400">
                        <span>{{ item.name }}</span>
                        <template v-if="item.description">
                            <br>
                            {{ item.description }}
                        </template>
                    </v-td>
                    <v-td name="mixedPrice" width="120" align="right">
                        <span>{{ item.mixedPrice }}</span>
                    </v-td>
                    <v-td name="tags" width="450">
                        <template v-if="item.status==='PARSED'">
                            <i style="font-size: 1.4em !important;" class="rot fa-xl fa-regular fa-gear"/>
                        </template>
                         <template v-if="item.status !=='PARSED' && service.status !=='DECLINED' && service.status !=='DECLINED_MANUAL'"
                                   v-for="service in item.services" >
                             <nobr>
                                <span :class="service.status">{{ service.name }}</span>

                                <span v-if="service.matchType === 'predict'">({{ Math.round(service.predict) }})</span>
                                <span v-if="service.matchType === 'code'">(По коду)</span>
                                <span v-if="service.matchType === 'direct'">(Точное)</span>
                                <span v-if="service.matchType === 'manual'">(Вручную)</span>

                                <i v-if="service.status === 'ACCEPTED_MANUAL'" class="fad fa-person-simple"/>

                                <span v-if="['ACCEPTED', 'ACCEPTED_MANUAL', 'NEW'].indexOf(service.status) !== -1 && $can('admin.pricelists.doctu.update')"
                                      @click.stop.prevent="manualDeleteTag(item,service.id)">
                                    <button style="width:19px" class="fad redHover tiny fa-xmark"></button>
                                </span>
                             </nobr>
                             <br/>
                        </template>
                    </v-td>
                    <v-td name="manualAction" width="25" align="left">
                            <span  v-if="item.status !=='PARSED' && $can('admin.pricelists.doctu.update')" class="trash-can" @click.stop.prevent="deleteRow(item)"><i class="fa-icon fa-trash-can"></i></span>
                    </v-td>
                </v-tr>
            </template>
        </v-table>
        <template v-slot:footer>
            <button class="greenHover" v-if="canAddLine" @click="createLine">Добавить услугу</button>
            <v-loading-component @click="setModerated" v-if="canModerate">
                <template slot-scope="{ loadingClass }">
                    <button :class="[{green: true}, loadingClass]">Подтвердить</button>
                </template>
            </v-loading-component>
            <button class="red" v-if="canDecline" @click="openDeclineModal">Отклонить</button>
            <button class="green"
                    v-if="$can('admin.pricelists.doctu.moderate') && priceListFileStatus === 'MODERATED'"
                    @click="publish">
                Опубликовать
            </button>
            <button class="red"
                    v-if="$can('admin.pricelists.doctu.moderate') && priceListFileStatus === 'PUBLISHED'"
                    @click="unpublish">
                Снять с публикации
            </button>
            <button class="redHover" v-if="canDelete" @click="deletePricelist">Удалить</button>
        </template>
        <line-edit :fileId="priceListFileId"
                   :minPredict="filter.minPredict"
                   ref="lineEdit"
                   :categories="categories"
                   v-bind="$props"/>
        <decline @decline="setModerationProblem" r-btn="Подтвердить отмену модерации" ref="declineModal"/>
    </v-dialog-old>
</template>

<script>
import LineEdit from "./LineEdit"
import Decline from "../Decline"
import MassEditDialog from "../MassActions/Dialog"

export default {
    props: {
        servicesTree: {type: Array}
    },
    components: {LineEdit, Decline, MassEditDialog},
    data:() => ({
        tries: 0,
        filter: {minPredict: 60},
        priceListFileId: '',
        priceListFileStatus: '',
        clinic_id: '',
        clinic_name: '',
        foundClinics: [],
        categories: [],
        selectedItems: [],
        allChecked: false,
        tableIsReady: false,
        lastCheckedRowIndex: null,
    }),
    mounted: function () {
        setInterval(() => {
            if(this.checkForNotMatched(this.$refs.table) && this.tries < 300){
                this.axios.post('doctu/' + this.priceListFileId + '/getLinesWithTags', {filter: this.$refs.table.filter, limit: 100})
                    .then(response => {
                        this.tries++;
                        this.$refs.table.rows = response.data.data;
                    })
            }
        }, 1000)

    },
    methods: {
        openMassActions() {
            this.selectedItemsUpdate()
            this.$refs.priceMassActionsDialog.open();
        },
        tableIsPreparing() {
            this.tableIsReady = false
            this.allChecked = false
        },
        tableIsReadyToOperate() {
            this.tableIsReady = true
            this.allChecked = this.checkAllRowsAreInSelected()
            this.lastCheckedRowIndex = null;
        },
        checkAllRowsAreInSelected() {
            return this.$refs.table.rows.every(obj => {
                return this.selectedItems.some(e => e.id === obj.id)
            })
        },
        checkAllRowsAreNotSelected() {
            return this.$refs.table.rows.every(obj => {
                return this.selectedItems.every(e => e.id !== obj.id)
            })
        },
        handleSelect() {
            if (this.tableIsReady) {
                if (this.checkAllRowsAreNotSelected()) {
                    this.selectAll()
                } else {
                    this.$modal('Снять галочки?', {
                        name: "Все",
                        callback: () => {
                           this.selectedItems = [];
                           this.allChecked = this.checkAllRowsAreInSelected();
                        }
                    }, {
                        name: "На странице",
                        callback: () => {
                            this.deselectAll();
                        }
                    });

                }
            }
        },
        selectAll() {
            if (this.$refs.table.rows.length > 0) {
                this.$refs.table.rows.forEach((price) => {
                    if (! this.selectedItems.some(priceLine => priceLine.id === price.id)) {
                        this.selectedItems.push(price)
                    }
                })
            }
            this.allChecked = this.checkAllRowsAreInSelected()
        },
        deselectAll() {
            this.$refs.table.rows.forEach((price) => {
                this.selectedItems = this.selectedItems.filter(selectedPrice => selectedPrice.id !== price.id)
            })
            this.allChecked = this.checkAllRowsAreInSelected()
        },
        checkItem(item, withShift, rowIndex) {
            if (this.isChecked(item)) {
                this.selectedItems = this.selectedItems.filter(function(priceLine) {
                    return priceLine.id !== item.id
                })
            } else {
                if (withShift && this.lastCheckedRowIndex !== null) {
                    this.$refs.table.rows.forEach((row, index) => {
                        if (rowIndex > 100) {
                            index += 100 * Math.floor(rowIndex / 100);
                        }
                        if (
                            (index >= this.lastCheckedRowIndex && index < rowIndex)
                            || (index < this.lastCheckedRowIndex && index + 1 >= rowIndex)
                        ) {
                            if (!this.isChecked(row)) {
                                this.selectedItems.push(row);
                            }
                        }
                    })
                } else {
                    this.selectedItems.push(item)
                }

                this.lastCheckedRowIndex = rowIndex;
            }

            this.allChecked = this.checkAllRowsAreInSelected()
        },
        isChecked(item) {
            return this.selectedItems.some(price => price.id === item.id)
        },
        updateTable(withReset) {
            if (withReset) {
                this.selectedItems = []
                this.allChecked = false
            }
            this.$refs.table.update()
        },
        selectedItemsUpdate () {
            this.selectedItems.forEach((item, index) => {
                this.selectedItems[index].category = this.$refs.table.rows[this.$refs.table.rows.findIndex((row) => row.id === item.id)].category
            })
        },
        checkForNotMatched (table){
            if (table !== undefined &&  table.rows.filter(row => row.status === 'PARSED').length > 0){
                return true;
            }
            return false;
        },
        handleRowClick: function (event, item, row, index) {
            if (event.target && event.target.name === 'checkThisItem') {
                this.checkItem(item, event.shiftKey, index)
                return;
            }
            if(item.status === 'PARSED' || !this.$can('admin.pricelists.doctu.update')){
                return;
            }
            row.startLoadingAnimation();
            let promise = this.$refs.lineEdit.show(item.id)
            promise.then(() => row.stopLoadingAnimation())
                .catch(() => row.stopLoadingAnimation());
            return promise;
        },
        createLine(){
            this.$refs.lineEdit.show()
        },
        deleteRow(line){
            if(line.status === 'PARSED'){return;}
            this.axios.post('doctu/lines/' + line.id + '/delete' )
                .then((response) => {
                    this.$refs.table.rows.splice(this.$refs.table.rows.findIndex((row) => row.id === line.id),1);
                    this.$refs.table.pagination.total--;
                });
        },
        show(id, status) {
            this.priceListFileId = id;
            this.priceListFileStatus = status;
            return this.$refs.dialog.show().then(() => {
                this.$nextTick(() => {
                    this.$refs.table.filterUpdate(this.filter);
                    this.$refs.table.update();
                    this.getCategories();
                });
            })
        },
        manualDeleteTag(line, tagId) {
            this.axios.post('doctu/lines/' + line.id + '/deleteTag/' + tagId)
                .then((response) => {
                    let rowIndex = this.$refs.table.rows.find((row) => row.id === line.id).services.find((service) => service.id === tagId).status = 'DECLINED_MANUAL'
                });
        },
        openDeclineModal() {
            this.$refs.declineModal.show();
        },
        publish() {
            this.axios.post('doctu/' + this.priceListFileId + '/checkPublished')
                .then((response) => {
                    if (response.data.alreadyHasPublished) {
                        this.$modal('У клиники есть опубликованный прайс-лист, он будет снят с публикации. Продолжить?', {
                            name: 'Да',
                            callback: () => {
                                this.sendPublishRequest();
                            }
                        }, {}, true, 'only-text-dialog');
                    } else {
                        this.sendPublishRequest();
                    }
                });
        },
        sendPublishRequest() {
            this.axios.post('doctu/' + this.priceListFileId + '/publish').then(() => {
                this.$parent.$refs.table.update();
                this.hide();
            });
        },
        unpublish() {
            this.axios.post('doctu/' + this.priceListFileId + '/unpublish').then(() => {
                this.$parent.$refs.table.update();
                this.hide();
            });
        },
        deletePricelist() {
            this.$modal('Вы уверены, что хотите удалить Прайс-лист? Отмена действия невозможна.', {
                name: 'Да',
                callback: () => {
                    this.axios.post('doctu/' + this.priceListFileId + '/delete').then(() => {
                        this.$parent.$refs.table.update();
                        this.hide();
                    });
                }
            });
        },
        setModerationProblem(comment) {
            this.axios.post('doctu/' + this.priceListFileId + '/moderation_problem', {reason: comment}).then((response) => {
                this.$parent.$refs.table.update();
                this.hide();
            });
        },
        setModerated(btn) {
            btn.startLoadingAnimation();
            this.axios.post('doctu/' + this.priceListFileId + '/moderate', {'predict': this.filter.minPredict}).then((response) => {
                btn.stopLoadingAnimation();
                this.$parent.$refs.table.update();
                this.hide();
            }, () => {
                btn.stopLoadingAnimation()
            });
        },
        getCategories() {
            this.axios.post('doctu/' + this.priceListFileId + '/getCategories').then((response) => {
                this.categories = response.data;
            });
        },
        hide() {
            this.resetData();
            this.$refs.dialog.hide();
        },
        resetData() {
            this.filter.minPredict = 60;
            this.priceListFileId = '';
            this.clinic_id = '';
            this.clinic_name = '';
            this.foundClinics = [];
            this.categories = [];
            this.selectedItems = []
        },
        updateTags(data) {
            this.selectedItems.forEach((item, index) => {
                if (data[item.id]) {
                    this.selectedItems[index].services = data[item.id];
                }
            })
        },
        exportPricelist() {
            window.open('doctu/' + this.priceListFileId + '/export');
        },
    },

    computed: {
        canAddLine () {
            return this.priceListFileStatus !== 'MODERATED'
                && this.priceListFileStatus !== 'PUBLISHED'
                && this.$can('admin.pricelists.doctu.update')
        },
        canModerate () {
            return this.priceListFileStatus !== 'MODERATED'
                && this.priceListFileStatus !== 'PUBLISHED'
                && this.$can('admin.pricelists.doctu.moderate')
        },
        canDecline () {
            return this.priceListFileStatus !== 'PUBLISHED' && this.$can('admin.pricelists.doctu.moderate')
        },
        canDelete () {
            return this.priceListFileStatus !== 'PUBLISHED' && this.$can('admin.pricelists.doctu.update')
        }
    }
}
</script>

<style lang="scss">
#step_three {
    max-height: 97vh !important;
}

.stepThreeTable {
    height: calc(70vh - 55px);

    @media (min-width: 1200px) {
        height: calc(80vh - 75px);
    }

    &.vuetable > .vuetableWrapper > .tbody-container > table > tbody > tr > td input[type=checkbox] {
        width: 17px;
        height: 17px;
    }
}

.fa-icon {
    font-family: 'Font Awesome 6 Pro';
    font-weight: 300;
    font-style: normal;
    font-variant: normal;
    text-rendering: auto;
    color: #a7a7a7;
}

.fa-icon:hover {
    font-weight: 900;
}

.fa-trash-can:hover{
    color: red !important;
}
.trash-can {
    display:none;
}

tr:hover .trash-can  {
    display:block;
}
.tagsBlock {
    display: block;
}

.DECLINED {
    text-decoration: line-through black;
}

.DECLINED_MANUAL {
    text-decoration: line-through underline black;
}
i.rot {
    color: #b9bec7a3;
    animation: 2s linear 0s normal none infinite running rot;
    -webkit-animation: 2s linear 0s normal none infinite running rot;
}
@keyframes rot {
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(360deg);
    }
}
@-webkit-keyframes rot {
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(360deg);
    }
}
</style>

<style scoped>
#pricelistMassEditCheckbox[checked] {
    background-image: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24'><path d='M20.285 2l-11.285 11.567-5.286-5.011-3.714 3.716 9 8.728 15-15.285z'/></svg>");
}
</style>
